<section class="py-24 overflow-hidden">
  <!-- Header -->
  <div class="flex justify-center mb-8" data-aos="fade-up">
    <span
      class="inline-flex items-center gap-2 bg-white border border-gray-200 rounded-full px-3 py-1.5 text-sm font-medium text-[#061430]"
    >
      <app-icon name="svg:logo-white" [size]="20" />
      {{ "recruiterProgram.advancedFeatures.badge" | translate }}
    </span>
  </div>
  <h2
    class="text-center text-[32px] md:text-[44px] lg:text-[52px] font-black leading-tight tracking-[-2px] text-[#000D4A] mb-16"
    data-aos="fade-up"
    data-aos-delay="50"
  >
    {{ "recruiterProgram.advancedFeatures.title" | translate }}
  </h2>

  <!-- Carousel -->
  <div class="relative" data-aos="fade-up" data-aos-delay="100">
    <swiper-container #swiper init="false" class="block">
      <swiper-slide
        *ngFor="let feature of features"
        class="!w-[calc(100vw-var(--page-padding)*2)] md:!w-[560px] !h-auto"
      >
        <div
          class="relative rounded-2xl border border-[#E2E8F0] bg-white overflow-hidden h-full"
        >
          <!-- Image -->
          <div class="h-[320px] md:h-[380px] overflow-hidden">
            <app-responsive-img
              basePath="assets/images/recruiter-program"
              [langAware]="false"
              [name]="feature.imageName"
              [alt]="feature.titleKey | translate"
              loading="lazy"
              imgClass="w-full h-full object-cover"
              sizes="(min-width: 768px) 560px, calc(100vw - var(--page-padding) * 2)"
            />
          </div>

          <!-- Text -->
          <div class="p-6">
            <h3 class="text-[22px] leading-[36px] font-[800] text-[#000d4a] mb-2">
              {{ feature.titleKey | translate }}
            </h3>
            <p class="text-[17px] leading-[30px] text-[#525866]">
              {{ feature.descKey | translate }}
            </p>
          </div>
        </div>
      </swiper-slide>
    </swiper-container>

    <!-- Arrow prev -->
    <button
      #prevBtn
      type="button"
      class="rtl:flip flex absolute top-[180px] start-2 z-10 w-8 h-8 md:w-[60px] md:h-[60px] items-center justify-center rounded-xl md:rounded-[20px] bg-white border shadow-[0px,24px,64px,-20px,#0061FF]"
    >
      <app-icon
        name="tabler:arrow-left"
        [size]="18"
        class="text-[#0367FB] md:!text-[22px]"
      />
    </button>

    <!-- Arrow next -->
    <button
      #nextBtn
      type="button"
      class="rtl:flip flex absolute top-[180px] end-2 z-10 w-8 h-8 md:w-[60px] md:h-[60px] items-center justify-center rounded-xl md:rounded-[20px] bg-white border shadow-[0px,24px,64px,-20px,#0061FF]"
    >
      <app-icon
        name="tabler:arrow-right"
        [size]="18"
        class="text-[#0367FB] md:!text-[22px]"
      />
    </button>
  </div>
</section>
